import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/@dva/shared/material-components.module';
import { NgModule } from '@angular/core';
import { ProgressPanelComponent } from './progress-panel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ScrollbarModule } from 'src/@dva/shared/scrollbar/scrollbar.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule, ScrollbarModule],
  declarations: [ProgressPanelComponent],
  exports: [ProgressPanelComponent],
})
export class ProgressPanelModule {}
